import React, {useState, useEffect} from "react"
import Button from "@material-ui/core/Button"
import {makeStyles} from "@material-ui/core/styles"
import MenuItem from "@material-ui/core/MenuItem"
import TextField from "@material-ui/core/TextField"
import "date-fns"
import Alert from "@material-ui/lab/Alert"
import {ValidationGroup, Validate, AutoDisabler} from "mui-validate"

import EventDataService from "../../services/EventService"
import DevicesDataService from "../../services/DeviceService"
import LocationDataService from "../../services/LocationService"
import DateFnsUtils from "@date-io/date-fns"
import {
	DateTimePicker,
	MuiPickersUtilsProvider,
	KeyboardDateTimePicker,
} from "@material-ui/pickers"

const useStyles = makeStyles(theme => ({
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
	root: props => ({
		"& .MuiTextField-root": {
			margin: theme.spacing(1),
			width: "25ch",
		},
		"& .MuiButton-root": {
			margin: theme.spacing(1),
		},
		"& .MuiAlert-root": {
			width: "100%",
			"& > * + *": {
				marginTop: theme.spacing(1),
			},
		},
	}),
}))

const AddEventForm = () => {
	const [loc] = React.useState(JSON.parse(localStorage.getItem("loc")).id || "")

	const [devices, setDevices] = useState([])

	useEffect(() => {
		retrieveDevices()
	}, [])

	const retrieveDevices = () => {
		if (JSON.parse(localStorage.getItem("loc")).id >= 0) {
			DevicesDataService.getAll(loc)
				.then(response => {
					setDevices(response.data)
				})
				.catch(e => {
					setErrorMessages(["Cannot load user data"])
					setIserror(true)
				})
		} else if (JSON.parse(localStorage.getItem("loc")).id == "all") {
			DevicesDataService.adminAll()
				.then(response => {
					setDevices(response.data)
				})
				.catch(e => {
					setErrorMessages(["Cannot load user data"])
					setIserror(true)
				})
		}
	}

	//for error handling
	const [iserror, setIserror] = useState(false)
	const [errorMessages, setErrorMessages] = useState([])

	// * Retrieve Locations Start
	const [locations, setLocations] = useState([])

	useEffect(() => {
		retrieveLocations()
	}, [])

	const retrieveLocations = () => {
		LocationDataService.getAll(loc)
			.then(response => {
				setLocations(response.data)
				console.log(response.data)
			})
			.catch(e => {
				console.log(e)
			})
	}
	// ! Retrieve Locations End

	const initialEventState = {
		id: null,
		device_mac: "",
		user_id: "",
		location: "",
		time: "",
		event: "",
		genuine: false,
	}

	const [manualEvent, setEvent] = useState(initialEventState)
	const [selectedDate, handleDateChange] = useState(new Date())
	const [submitted, setSubmitted] = useState(false)

	const handleInputChange = event => {
		const {name, value} = event.target
		setEvent({...manualEvent, [name]: value})
	}

	const saveEvent = () => {
		var data = {
			device_mac: manualEvent.device_mac,
			user_id: manualEvent.user_id,
			location: manualEvent.location,
			time: selectedDate,
			event: manualEvent.event,
			genuine: manualEvent.genuine,
		}

		EventDataService.create(data)
			.then(response => {
				setEvent({
					id: response.data.id,
					device_mac: response.data.device_mac,
					user_id: response.data.user_id,
					location: response.data.location,
					time: response.data.time,
					event: response.data.event,
					genuine: response.data.genuine,
				})
				setSubmitted(true)
				console.log(response.data)
				// setTimeout(function () {
				//     window.location.reload(1);
				// }, 2000);
			})
			.catch(e => {
				console.log(e)
			})
	}

	const newEvent = () => {
		setEvent(initialEventState)
		setSubmitted(false)
	}

	const classes = useStyles()

	return (
		<div className='submit-form'>
			{submitted ? (
				// <Alert onClose={() => { }}>Успешно добавен!</Alert>
				<div>
					<Alert>Успешно добавихте събитието!</Alert>
					{/* <h4>You submitted successfully!</h4>
                    <button className="btn btn-success" onClick={newUser}>
                        Add
                    </button> */}
				</div>
			) : (
				<ValidationGroup>
					<form className={classes.root}>
						<div>
							<Validate name='device' required>
								<TextField
									id='outlined-select-location device_mac'
									select
									label='Устройство'
									name='device_mac'
									value={manualEvent.device_mac}
									onChange={handleInputChange}
									size='small'
									variant='outlined'>
									<MenuItem></MenuItem>
									{devices.map(device => (
										<MenuItem key={device.mac} value={device.mac}>
											{device.name}
										</MenuItem>
									))}
								</TextField>
							</Validate>
							<Validate name='user' required>
								<TextField
									required
									id='outlined-required user_id'
									type='number'
									label='Номер на Служител'
									variant='outlined'
									name='user_id'
									value={manualEvent.user_id}
									onChange={handleInputChange}
									size='small'
								/>
							</Validate>
						</div>
						<div>
							<Validate
								name='location'
								required={[true, "Това поле е задължително!"]}>
								<TextField
									id='outlined-select-location location'
									select
									label='Локация'
									name='location'
									value={manualEvent.location}
									onChange={handleInputChange}
									size='small'
									variant='outlined'>
									<MenuItem></MenuItem>
									{locations.map(location => (
										<MenuItem key={location.number} value={location.number}>
											{location.name}
										</MenuItem>
									))}
								</TextField>
							</Validate>
							<Validate
								name='event'
								required={[true, "Това поле е задължително!"]}>
								<TextField
									id='outlined-select-location event'
									select
									label='Вид Събитие'
									name='event'
									value={manualEvent.event}
									onChange={handleInputChange}
									size='small'
									variant='outlined'>
									<MenuItem></MenuItem>
									<MenuItem key='enter' value='enter'>
										Вход
									</MenuItem>
									<MenuItem key='exit' value='exit'>
										Изход
									</MenuItem>
								</TextField>
							</Validate>
						</div>
						<div>
							<MuiPickersUtilsProvider utils={DateFnsUtils}>
								<KeyboardDateTimePicker
									id='time'
									name='time'
									variant='inline'
									ampm={false}
									label='Дата и час'
									helperText='Формат: 2021-12-25 10:58'
									value={selectedDate ? selectedDate : null}
									onChange={handleDateChange}
									onError={console.log}
									format='yyyy-MM-dd HH:mm'
								/>
							</MuiPickersUtilsProvider>
						</div>
						<AutoDisabler>
							<Button onClick={saveEvent} variant='contained' color='primary'>
								Добави
							</Button>
						</AutoDisabler>
					</form>
				</ValidationGroup>
			)}
		</div>
	)
}

export default AddEventForm
